import React from 'react';
import { useCustomers } from './hooks/useCustomers';
import CustomerToolbar from './components/CustomerToolbar';
import CustomerList from './components/CustomerList';
import CustomerTile from './components/CustomerTile';
import CustomerModal from './components/CustomerModal';
import BulkActionBar from '../../../components/shared/BulkActionBar';
import './Customers.css';

/**
 * Main orchestrator for Customer Management.
 */
export default function Customers() {
    const {
        customers,
        loading,
        searchTerm,
        setSearchTerm,
        statusFilter,
        setStatusFilter,
        viewMode,
        setViewMode,
        selectedIds,
        setSelectedIds,
        isModalOpen,
        setIsModalOpen,
        currentCustomer,
        modalMode,
        openCreate,
        openEdit,
        handleSave,
        handleDelete,
        handleBulkStatus,
        handleBulkDelete
    } = useCustomers();

    return (
        <div className="customers-container">
            <CustomerToolbar 
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                statusFilter={statusFilter}
                setStatusFilter={setStatusFilter}
                viewMode={viewMode}
                setViewMode={setViewMode}
                onAdd={openCreate}
            />

            {selectedIds.length > 0 && (
                <div className="bulk-action-wrapper">
                    <BulkActionBar 
                        selectedCount={selectedIds.length}
                        onClearSelection={() => setSelectedIds([])}
                        actions={[
                            {
                                label: 'Status: Aktiv',
                                icon: '🟢',
                                onClick: () => handleBulkStatus('aktiv')
                            },
                            {
                                label: 'Status: Inaktiv',
                                icon: '🔴',
                                onClick: () => handleBulkStatus('inaktiv')
                            },
                            {
                                label: 'Löschen',
                                icon: '🗑️',
                                variant: 'danger',
                                onClick: handleBulkDelete
                            }
                        ]}
                    />
                </div>
            )}

            <div className="customers-content">
                {loading ? (
                    <div className="loading-state">
                        <div className="skeleton-list">
                            {[...Array(5)].map((_, i) => (
                                <div key={i} className="skeleton-item" />
                            ))}
                        </div>
                    </div>
                ) : customers.length === 0 ? (
                    <div className="empty-state">
                        <p>Keine Kunden gefunden.</p>
                        <button className="btn-primary" onClick={openCreate}>Ersten Kunden anlegen</button>
                    </div>
                ) : viewMode === 'list' ? (
                    <CustomerList 
                        customers={customers} 
                        selectedIds={selectedIds}
                        onSelect={setSelectedIds}
                        onEdit={openEdit}
                        onDelete={handleDelete}
                    />
                ) : (
                    <div className="customer-tiles-grid">
                        {customers.map(customer => (
                            <CustomerTile 
                                key={customer.id} 
                                customer={customer} 
                                onEdit={() => openEdit(customer)}
                            />
                        ))}
                    </div>
                )}
            </div>

            <CustomerModal 
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                customer={currentCustomer}
                mode={modalMode}
                onSave={handleSave}
            />
        </div>
    );
}
